import Vue from 'vue'
import checkView from 'vue-check-view'
Vue.use(checkView);
